module.exports = __webpack_public_path__ + "img/Video-portada.733586a9.jpg";